// extracted by mini-css-extract-plugin
export default {"main":"GalaList_main__xV6Z7","more":"GalaList_more__H-w2L","grid":"GalaList_grid__gLtTP","item":"GalaList_item__IYm4W"};